import { parseOnlyNumericValue, safeToString, sliceText } from "../../../utils/common";

export const SALARY_DETAILS_CONST = {
    salary_type: {
        fullWidth: true,
        required: true,
        label: "Salary Type",
        options: [
            { id: "fixed", name: "Fixed Amount" },
            { id: "wages", name: "Wages" }
        ],
        placeholder: "Select Here...",
        type: "select",
        name: "salary_type"
    },
    payment_mode: {
        fullWidth: true,
        required: true,
        label: "Payment Mode",
        options: [
            { id: "one-time", name: "One Time" },
            { id: "Monthly", name: "Monthly" }
        ],
        placeholder: "Select Here...",
        type: "select",
        name: "payment_mode"
    },
    ammount: {
        fullWidth: true,
        required: true,
        label: "Amount",
        placeholder: "Type Here...",
        type: "number",
        name: "ammount"
    },
    payment_by: {
        fullWidth: true,
        required: true,
        label: "Payment By",
        options: [
            { id: "account_transfer", name: "Account Transfer" },
            { id: "cheque", name: "Cheque" },
            { id: "cash", name: "Cash" }
        ],
        placeholder: "Select Here...",
        type: "select",
        name: "payment_by"
    },
    wages_type: {
        fullWidth: true,
        required: true,
        label: "Wages Type",
        options: [
            { id: "days", name: "Days" },
            { id: "hours", name: "Hours" },
            { id: "per", name: "Per/Pieces" }
        ],
        placeholder: "Select Here...",
        type: "select",
        name: "wages_type"
    },
    wages_rate: {
        fullWidth: true,
        required: true,
        label: "Wages Rate",
        placeholder: "Type Here...",
        type: "number",
        name: "wages_rate"
    },
    wages_payment_mode: {
        fullWidth: true,
        required: true,
        label: "Wages Payment Mode",
        options: [
            { id: "weekly", name: "Weekly" },
            { id: "fortnight_pay", name: "Fortnight pay" },
            { id: "monthly", name: "Monthly" }
        ],
        placeholder: "Select Here...",
        type: "select",
        name: "wages_payment_mode"
    },
    wages_days: {
        fullWidth: true,
        required: true,
        label: "Wages Days",
        placeholder: "Type Here...",
        type: "number",
        name: "wages_days",
        customOptions: {
            formatValueFn: (value) => sliceText(parseOnlyNumericValue(safeToString(value)), 10)
        }
    },

    bank_name: {
        fullWidth: true,
        required: true,
        label: "Bank Name",
        placeholder: "Type Here...",
        type: "text",
        name: "bank_name"
    },
    branch_name: {
        fullWidth: true,
        required: true,
        label: "Branch Name",
        placeholder: "Type Here...",
        type: "text",
        name: "branch_name"
    },
    account_number: {
        fullWidth: true,
        required: true,
        label: "Account Number",
        placeholder: "Type Here...",
        type: "number",
        name: "account_number",
        customOptions: {
            formatValueFn: (value) => sliceText(parseOnlyNumericValue(safeToString(value)), 18)
        }
    },
    ifsc_code: {
        fullWidth: true,
        required: true,
        label: "IFSC Code",
        placeholder: "Type Here...",
        type: "text",
        name: "ifsc_code",
        customOptions: {
            formatValueFn: (value) => sliceText(safeToString(value), 11)
        }
    },
    document_type:{
        fullWidth:true,
        label:"Document Type",
        placeholder:"Select Here...",
        name:"document_type"
      },
      document_number:{type:"text",
      fullWidth:true,
      label:"Number/Code",
      placeholder:"Type Here...",
      name:"document_number"
    }

};
